import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './modules/auth/services/guard/auth-guard.service';
import { PageNonAutoriseComponent } from './modules/auth/components/page-non-autorise/page-non-autorise.component';
import { PageNonTrouveeComponent } from './modules/auth/components/page-non-trouvee/page-non-trouvee.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./budget/budget.routes').then(m => m.BUDGET_ROUTES),
    canActivate: [authGuard],
    data: { roles: ['ROLE_USER'], breadcrumb: 'Budget' },
    pathMatch: 'full'
  },
  {
    path: 'commande',
    loadChildren: () => import('./commande/commande.module').then(m => m.CommandeModule),
    canActivate: [authGuard],
    data: { roles: ['ROLE_USER'], breadcrumb: 'Commande' }
  },
  {
    path: 'marche',
    loadChildren: () => import('./marche/marche.module').then(m => m.MarcheModule),
    canActivate: [authGuard],
    data: {
      roles: ['ROLE_SAF', 'ROLE_CHEF_SERVICE', 'ROLE_DIR_SOUSDIR', 'ROLE_CPRA', 'ROLE_USER'],
      breadcrumb: 'Marchés'
    }
  },
  {
    path: 'budget',
    loadChildren: () => import('./budget/budget.routes').then(m => m.BUDGET_ROUTES),
    canActivate: [authGuard],
    data: { roles: ['ROLE_SAF', 'ROLE_DIR_SOUSDIR', 'ROLE_CHEF_SERVICE', 'ROLE_CPRA'], breadcrumb: 'Budget' }
  },
  {
    path: 'validation-virement',
    loadComponent: () => import('./budget/validation-virement/validation-virement.component').then(m => m.ValidationVirementComponent),
    canActivate: [authGuard],
    data: { roles: ['ROLE_SAF', 'ROLE_DIR_SOUSDIR', 'ROLE_CHEF_SERVICE', 'ROLE_CPRA'], breadcrumb: 'Validation virements' }
  },

  {
    path: 'historique-virement',
    loadComponent: () =>
      import('./budget/liste-historique-virement/liste-historique-virement.component').then(m => m.ListeHistoriqueVirementComponent),
    canActivate: [authGuard],
    data: { roles: ['ROLE_USER'] }
  },
  {
    path: 'bascule',
    loadChildren: () => import('./bascule/bascule.module').then(m => m.BasculeModule),
    canActivate: [authGuard],
    data: { roles: ['ROLE_SAF'] }
  },
  {
    path: 'administration',
    loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [authGuard],
    data: { roles: ['ROLE_SAF'], breadcrumb: 'Administration' }
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
    canActivate: [authGuard],
    data: { roles: ['ROLE_ADMIN'], breadcrumb: 'Configuration' }
  },
  {
    path: 'utilisateur',
    loadChildren: () => import('./utilisateur/utilisateur.module').then(m => m.UtilisateurModule),
    canActivate: [authGuard],
    data: { roles: ['ROLE_SAF', 'ROLE_DIR_SOUSDIR', 'ROLE_CHEF_SERVICE', 'ROLE_CPRA'] }
  },
  { path: '404', component: PageNonTrouveeComponent },
  { path: '**', component: PageNonAutoriseComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
